/* eslint-disable no-nested-ternary */
import React from 'react';
import CustomHtmlRender from './CustomHtmlRender';
export default function RenderPropsWrapper({ props, children, override, htmlOverride, topLevelAttributes, }) {
    const isRenderProps = typeof override === 'function';
    const isJSX = typeof override === 'object';
    const isHtmlOverride = typeof htmlOverride === 'function';
    return (React.createElement(React.Fragment, null, isRenderProps ? (override(props)) : isJSX ? (override) : isHtmlOverride ? (React.createElement(CustomHtmlRender, { ...props, renderHtml: htmlOverride, topLevelAttributes: topLevelAttributes })) : (
    // Default implementation
    children)));
}
